import React from "react";

export default function Copyright() {
  return (
    <div className="footer bg-[#000] py-4 md:py-4 border border-[#000] border-t-[#666666]">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
          <p className="col-span-2 text-[14px] text-[#999999]">
            Copyright © 2024 Nudgie AI. All rights reserved.
          </p>
          {/* <p className="text-[14px] text-[#999999]">
            <a href="#"></a>
          </p>
          <p className="text-[14px] text-[#999999]">
            <a href="privacy.html">Privacy Policy</a>
          </p> */}
        </div>
      </div>
    </div>
  );
}
